/**
 * Synchronous header layout bootstrap — runs during header section parse.
 * Menu overlap + dynamic height vars must settle before first paint of FWM.
 * `header.js` re-runs overlap on resize; this only handles initial layout.
 */
(function () {
  function bootstrapHeader() {
    const header = document.getElementById('header');
    if (!header || header.dataset.headerBootstrapApplied === '1') return;

    const menuItems = header.querySelector('.header-menu-items');
    const menuWrapper = header.querySelector('.header--Wrapper');
    if (!menuItems || !menuWrapper) return;

    const linkHeights = [];
    header.querySelectorAll('.header-main-links').forEach((link) => {
      linkHeights.push(link.offsetHeight);
    });

    const maxHeight = linkHeights.length ? Math.max.apply(null, linkHeights) : 0;
    const minHeight = linkHeights.length ? Math.min.apply(null, linkHeights) : 0;
    const overlapping = maxHeight > minHeight;

    window.theme = window.theme || {};

    if (overlapping && (!window.theme.menuBreakpoint || window.theme.menuBreakpoint === 0)) {
      window.theme.menuBreakpoint = Math.max(
        document.body.scrollWidth,
        document.documentElement.scrollWidth,
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth
      );
    }

    const menuBreakpoint = window.theme.menuBreakpoint || 0;
    const currentClientWidth = document.documentElement.clientWidth;

    if (currentClientWidth > menuBreakpoint) {
      menuItems.classList.remove('mt-m', 'mainMenu--Overlapping');
      menuWrapper.querySelector('.header-main-menu-items')?.prepend(menuItems);
      window.theme.menuBreakpoint = 0;
    } else if (overlapping) {
      menuItems.classList.add('mt-m', 'mainMenu--Overlapping');
      header.appendChild(menuItems);
    }

    const height = Math.round(header.offsetHeight);
    if (height > 0) {
      const px = `${height}px`;
      const root = document.documentElement.style;
      root.setProperty('--header-height', px);
      root.setProperty('--submenu-position', px);
      root.setProperty('--header-dynamic-height', px);
    }

    header.dataset.headerBootstrapApplied = '1';
  }

  bootstrapHeader();
})();
